import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ShortTerm.css";

const ShortTermMemoryTest = () => {
useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, []);
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(null);

  useEffect(() => {

    const email = localStorage.getItem("user_email");

    if (!email) {
      navigate("/");
      return;
    }

    axios
      .get(`/check-access?email=${email}&test=short_term_memory`)
      .then(res => {

        console.log("API:", res.data);

        if (res.data.allowed) {
          setHasAccess(true);
        } else {
          setHasAccess(false);
        }

      })
      .catch(() => navigate("/"));

  }, []);

  if (hasAccess === null) {
    return <div>Loading...</div>;
  }

  if (hasAccess === false) {
    return (
      <div className="access-denied-container">
        <h2>🚫 Access Denied</h2>
        <p>You don’t have access to this test</p>
        <button onClick={() => navigate("/")}>Go Back</button>
      </div>
    );
  }

  return (
    <div className="rg-login-wrapper">

      {/* ================= HEADER ================= */}

      <div className="reaction-header-card">

        <h2 className="reaction-title">Short-Term Memory Test</h2>

        <p className="reaction-subtitle">
          Short-term memory is your ability to store small amounts of information
          for a brief period and recall it quickly.
          It trains your brain to 
          <strong> “See → Store → Recall.”</strong>
        </p>

        <div className="reaction-pill">
          Test type: <strong>Memory → Short-Term Memory</strong>
        </div>

        <hr className="reaction-divider" />

        {/* ================= WHY ================= */}

        <div className="reaction-why-card">

          <h3 className="why-title">
            Why short-term memory matters
          </h3>

          <p className="why-description">
            Short-term memory is essential for quick thinking and real-time actions.
            It helps you process information instantly — useful in exams, conversations,
            and fast decision-making situations.
          </p>

          <div className="why-tags">
            <span>Quick recall ability</span>
            <span>Better concentration</span>
            <span>Improved learning speed</span>
            <span>Stronger mental clarity</span>
            <span>Faster reactions</span>
          </div>

        </div>

      </div>

      {/* ================= HOW ================= */}

      <div className="how-card">

        <h2 className="how-title">How the game works</h2>

        <ul className="how-list">

          <li>
            A set of numbers or patterns will appear briefly.
          </li>

          <li>
            Observe and remember them carefully.
          </li>

          <li>
            After they disappear, reproduce what you saw.
          </li>

          <li>
            Difficulty increases as you progress.
          </li>

          <li>
            The game ends when you make an error.
          </li>

        </ul>

        <p className="how-note">
          Tip: Focus sharply — even 1 second matters.
        </p>

      </div>

      {/* ================= START ================= */}

      <div className="start-test-section">

        <h2>Ready to test your memory?</h2>

        <button
          className="start-test-btn"
          onClick={() => navigate("/short-term-memory/play")}
        >
          Start Test
        </button>

      </div>

    </div>
  );
};

export default ShortTermMemoryTest;